<template>
	<vs-col>
		<a @click="open" class="edit" v-if="!popupActivo">{{value}}
			<font-awesome-icon class="edit-icon fa-icon" :icon="['fas', 'pencil-alt']" />
		</a>
		<vx-input-group v-else-if="popupActivo">
			<template slot="prepend">
				<div class="prepend-text btn-addon">
					<vs-button color="danger" type="border" @click.native="cancel">
						<font-awesome-icon class="fa-icon" :icon="['fas', 'times']" style="font-size: 1.2rem" />
					</vs-button>
				</div>
			</template>

			<vs-input ref="input" name="input" v-validate="validateRules" v-model="editValue" />

			<template slot="append">
				<div class="append-text btn-addon">
					<vs-button @click.native="submit" class="btn-changeName" color="success"
							   type="border">
						<font-awesome-icon class="fa-icon" :icon="['fas', 'check']" style="font-size: 1.2rem" />
					</vs-button>
				</div>
			</template>
		</vx-input-group>

		<span class="text-danger text-sm" v-show="errors.has('input')">{{ errors.first('input') }}</span>
	</vs-col>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate);

export default{
	name: 'inline-input',
	props: {
		value: {
			required: true,
			type: String | null,
		},
		method: {
			type: Function,
		},
		validateRules: {
			default: '',
		},
		validateMessages: {
			default: { },
		}
	},
	data() {
		return {
			editValue: this.value,
			rules: this.rules,
			popupActivo: false,
			dict: {
				custom: {
					input: this.validateMessages,
				}
			}
		}
	},
	methods: {
		submit() {
			if (this.popupActivo) {
				this.$validator.validateAll().then(result => {
					if (result) {
						this.$emit('submit', this.editValue);
						this.popupActivo = false;
					}
				})
			}
		},
		cancel() {
			if (this.popupActivo) {
				this.$emit('cancel');
				this.editValue = this.value;
				this.popupActivo = false;
			}
		},
		open() {
			this.popupActivo = true;
		}
	},
	created() {
		this.$validator.localize('en', this.dict);
		window.addEventListener('keyup', event => {
			if (event.keyCode === 13) {
				this.submit()
			}
			if (event.keyCode === 27) {
				this.cancel()
			}
		})
	}
}
</script>

<style scoped>
	.edit {
		border-bottom: 1px dotted #007bff;
		color: #007bff;
		text-decoration: none;
		cursor: pointer;
	}
</style>

